


























































import { Component, Vue } from 'vue-property-decorator';
import * as amplitude from 'amplitude-js';

import {
  PromoCardShortDTO,
  StoryAdminDTO,
} from '@/api';
import services from '@/services';
import UserMenu from '@/components/UserMenu.vue';
import MainNavbar from '@/components/MainNavbar.vue';

@Component({
  name: 'clients',
  components: {
    UserMenu,
    MainNavbar,
  },
})
export default class Clients extends Vue {
  loading = false;

  total: number | null = null;

  cards: PromoCardShortDTO[] = [];

  stories: StoryAdminDTO[] = [];

  async created() {
    amplitude.getInstance().logEvent('Открыта страница промо-карточек');
    services
      .promoCardApi()
      .promoCardEndpointGetCards()
      .then(r => r.data)
      .then((cards) => {
        this.cards = cards;
        this.total = cards.length;
      });
    services
      .storiesApi()
      .storiesEndpointGetStories()
      .then(r => r.data)
      .then((cards) => {
        this.stories = cards;
      });
  }

  deletePromo(id: number) {
    services
      .promoCardApi()
      .promoCardEndpointDeleteCard(id)
      .then(({ data }) => data)
      .then(() => {
        const index = this.cards.findIndex(card => card.id === id);
        this.stories.splice(index, 1);
      });
  }

  deleteStory(id: number) {
    services
      .storiesApi()
      .storiesEndpointDeleteStory(id)
      .then(({ data }) => data)
      .then(() => {
        const index = this.stories.findIndex(story => story.id === id);
        this.stories.splice(index, 1);
      });
  }
}
